import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../UI/Button';
import { contributorStatusLabel, isApprovedContributor, ContributorApplication } from '../../utils/contributorApplications';

const ContributorApplicationLocked: React.FC<{
  role: 'mentor' | 'interviewer';
  application: ContributorApplication;
}> = ({ role, application }) => {
  const approved = isApprovedContributor(application);
  const label = role === 'mentor' ? 'Mentor' : 'Interviewer';
  const tab = role === 'mentor' ? 'academy' : 'interviews';
  return (
    <div className="max-w-xl mx-auto px-4 py-16 text-center">
      <p className="text-lg font-semibold text-gray-900">
        {approved ? `You are an approved ${label.toLowerCase()}.` : `Your ${label.toLowerCase()} application is already submitted.`}
      </p>
      <p className="mt-2 text-sm text-gray-600">
        Application status: <span className="font-semibold text-gray-900">{contributorStatusLabel(application)}</span>
      </p>
      {application.displayStatus === 'Rejected' && application.rejectionReason ? (
        <p className="mt-2 text-sm text-gray-500">{application.rejectionReason}</p>
      ) : null}
      <Link to={`/dashboard?tab=${tab}`} className="mt-6 inline-flex">
        <Button>Go to dashboard</Button>
      </Link>
    </div>
  );
};

export default ContributorApplicationLocked;
